'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _entries = require('babel-runtime/core-js/object/entries');

var _entries2 = _interopRequireDefault(_entries);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

exports.buildMapioURL = buildMapioURL;
exports.addFeatureProperties = addFeatureProperties;
exports.removeFeatureProperties = removeFeatureProperties;

var _base64Url = require('base64-url');

var _base64Url2 = _interopRequireDefault(_base64Url);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Sestaví URL mapio serveru.
 *
 * @param {string} serverURL - základ URL
 * @param {object} [options] - extra parametry pro generování. Všechny parametry (vyjma těch
 *                             uvedených níže) budou připojeny ve query části URL.
 * @param {string} [options.path] - cesta pro připojení k URL
 * @param {string} [options.topic] - téma konfigurace
 * @param {object} [options.context] - kontextové parametry
 * @returns {string} URL
 */
function buildMapioURL(serverURL) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var path = options.path,
        topic = options.topic,
        context = options.context,
        urlParams = (0, _objectWithoutProperties3.default)(options, ['path', 'topic', 'context']);


    var url = serverURL;

    if (path) {
        if (url[url.length - 1] !== '/' && path[0] !== '/') {
            url += '/';
        }
        url += path;
    }

    if (topic) {
        urlParams.topic = topic;
    }

    if (context && isNotEmpty(context)) {
        urlParams.context = _base64Url2.default.encode(serializeParams(context));
    }

    if (isNotEmpty(urlParams)) {
        url += '?' + serializeParams(urlParams);
    }

    return url;
}

function isNotEmpty(params) {
    return (0, _keys2.default)(params).length > 0;
}

function serializeParams(params) {
    return (0, _entries2.default)(params).filter(function (_ref) {
        var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
            key = _ref2[0],
            value = _ref2[1];

        return value != null;
    }).map(function (_ref3) {
        var _ref4 = (0, _slicedToArray3.default)(_ref3, 2),
            key = _ref4[0],
            value = _ref4[1];

        return key + '=' + value;
    }).join('&');
}

/**
 * Vytvoří kopii feature s přidanými properties.
 *
 * @param feature - feature
 * @param properties - properties pro přidání
 * @returns {*} nová feature
 */
function addFeatureProperties(feature, properties) {
    return (0, _extends3.default)({}, feature, {
        properties: (0, _extends3.default)({}, feature.properties || {}, properties)
    });
}

/**
 * Vytvoří kopii feature s odebranými properties.
 *
 * @param feature - feature
 * @param properties -  názvy properties pro odebrání
 * @returns {*} nová feature
 */
function removeFeatureProperties(feature, names) {
    var properties = feature.properties,
        newFeature = (0, _objectWithoutProperties3.default)(feature, ['properties']);

    var newProperties = properties ? (0, _extends3.default)({}, properties) : {};
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = (0, _getIterator3.default)(names), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var name = _step.value;

            delete newProperties[name];
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    if (isEmpty(newProperties)) {
        return newFeature; // Nechceme zbytečně vracet prázdné properties, aby se zjednodušila případná serializovaná forma
    }
    return (0, _extends3.default)({}, newFeature, { properties: newProperties });
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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